import { graphql, useStaticQuery } from 'gatsby';
import React, { FC, useContext } from 'react';

import NextStepsStep, { INextStepsStepPageContent } from '@ui/templates/NextStepsStep';

import { keysToCamel } from '@utils/butter';
import { doesNotExist } from '@utils/general';

import FlowContext from '@providers/FlowContextProvider';

import { IFlowStepProps } from '@folx-types/flow-steps';

interface INextStepsStepPageProps extends IFlowStepProps {}

const NextStepsStepPage: FC<INextStepsStepPageProps> = ({ path, stepKey }) => {
	const { pageContent } = useStaticQuery(graphql`
		{
			pageContent: butterPage(slug: { eq: "membership-next-steps" }) {
				page_header
				page_description
				get_care_label
				get_care_href
				explore_label
				explore_href
			}
		}
	`);

	const { existingFormData, handleFormSubmission, handleNavBack } = useContext(FlowContext);

	const refinedContent: INextStepsStepPageContent = keysToCamel(
		pageContent
	) as INextStepsStepPageContent;

	return (
		<NextStepsStep
			loading={doesNotExist(pageContent)}
			pageContent={refinedContent}
			path={path}
			stepKey={stepKey}
			existingFormData={existingFormData}
			handleFormSubmission={handleFormSubmission}
			handleNavBack={handleNavBack}
		/>
	);
};

export default NextStepsStepPage;
